// import { get } from 'lodash';
import { Storage } from './storage'

export const checkAuthState = () => Storage.getData('isLoggedIn')

export const getLoggedUser = () => Storage.getData('currentUser')
